import { render } from "./FinalizadoComponent.vue?vue&type=template&id=595aa007&scoped=true"
import script from "./FinalizadoComponent.vue?vue&type=script&lang=js"
export * from "./FinalizadoComponent.vue?vue&type=script&lang=js"

import "./FinalizadoComponent.vue?vue&type=style&index=0&id=595aa007&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595aa007"]])

export default __exports__